import { render, staticRenderFns } from "./TalentPool.vue?vue&type=template&id=0c5bef89&scoped=true&"
import script from "./TalentPool.vue?vue&type=script&lang=js&"
export * from "./TalentPool.vue?vue&type=script&lang=js&"
import style0 from "./TalentPool.vue?vue&type=style&index=0&id=0c5bef89&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5bef89",
  null
  
)

export default component.exports